
function ItemsNotFound({Class="d-none" , text=""}){

	return <p className={Class}>{text}</p>
}

export default ItemsNotFound